import meta from '../metas/select-tree';
import request from '../utils/request';
import { readDataFromListPath, flatToTree } from '../utils/widgetUtils';
export default {
  meta,
  props: {
    remote: Object,
    multiple: {
      type: Boolean,
      default: true
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    labelKey: {
      type: String,
      default: 'label'
    }
  },
  data: function () {
    return {
      props: {
        multiple: true,
        value: this.valueKey,
        label: this.labelKey,
        emitPath: false
      },
      remoteData: []
    };
  },
  computed: {
    renderOptions() {
      if (!this.remote) {
        return this.$attrs.options;
      }

      return this.remoteData;
    }

  },

  created() {
    if (this.remote) {
      this.loadOptions();
    }
  },

  methods: {
    loadOptions() {
      const {
        formData = {}
      } = this;
      const {
        url,
        method,
        query = {},
        listQuery,
        listPath = 'data'
      } = this.remote;

      if (listQuery && formData) {
        listQuery.forEach(({
          name,
          relation
        }) => {
          query[name] = formData[relation];
        });
      }

      request({
        url,
        method,
        query
      }).then(res => {
        this.remoteData = flatToTree(readDataFromListPath(listPath, res));
      }).catch(e => {
        console.error(e);
        this.remoteData = [];
      });
    }

  }
};